import React from 'react';
import { PREFIX } from './constants';
export const CanvasService = () => {
    return (React.createElement("div", { className: `${PREFIX}-canvas-panel` },
        React.createElement("span", null, "\u672A\u9009\u4E2D")));
};
//# sourceMappingURL=canvas.js.map